import { render, staticRenderFns } from "./TabRide.vue?vue&type=template&id=c15d8f34&scoped=true&"
import script from "./TabRide.vue?vue&type=script&lang=js&"
export * from "./TabRide.vue?vue&type=script&lang=js&"
import style0 from "./TabRide.vue?vue&type=style&index=0&id=c15d8f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15d8f34",
  null
  
)

export default component.exports